
<script setup lang="ts">



</script>


<template>
  <div class="landing-wrapper">
    <q2-text class="intro" variant="body-sm">Build Configuration </q2-text>
    <q2-text class="titleLogin" variant="display-md">Images</q2-text>
    <q2-text class="description" variant="body-md">
        Coming Soon
    </q2-text>
  </div>
</template>

<style>
.landing-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
  text-align: center;
  background: #fdf8ff;
  --tct-btn-primary-background: #594bab;
  --tct-btn-primary-active-background: #594bab;
  --tct-btn-primary-box-shadow: none;
  --tct-btn-border-radius: 5px;
  --tct-btn-padding: 12px 20px;
}

.intro {
  font-weight: 500;
  color: #404040;
  margin-bottom: 15px
}

.titleLogin {
  font-weight: 800;
  color: #404040;
  font-size: 2.75rem;
  margin-bottom: 1rem;
}

.description {
  color: #404040;
  font-size: 1.125rem;
  max-width: 600px;
  margin-bottom: 2rem;
}
</style>
